import React from 'react';
import { Button } from '@sweetgreen/garnish';

import { useLocalizationContext } from '@order/Localization';

export const SweetpassCheckoutCta = (
  props: React.ComponentProps<typeof Button>,
) => {
  const { t } = useLocalizationContext();

  return (
    <Button size="large" palette="primary" {...props}>
      {t('sweetpass.checkout.upgrade-cta')}
    </Button>
  );
};
